import React from 'react';
import { AdaptiveFilterBar } from '../../../shared/components/patterns';
import { CLIENT_TYPES } from '@/modules/clients/constants/client.constants';

const clientsFilterConfig = {
  search: {
    key: 'query',
    placeholder: 'Cerca cliente o azienda...',
  },
  groups: [
    {
      key: 'tipoCliente',
      label: 'Tipo cliente',
      selection: 'single',
      emptyValue: CLIENT_TYPES.ALL,
      options: [
        { value: CLIENT_TYPES.CEDENTE, label: 'Cedente' },
        { value: CLIENT_TYPES.CESSIONARIO, label: 'Cessionario' },
        { value: CLIENT_TYPES.OTHER, label: 'Altro' },
      ],
    },
  ],
};

function ClientsFilters({ filters, onSearchChange, onTipoChange, onReset, activity }) {
  return (
    <AdaptiveFilterBar
      config={{ ...clientsFilterConfig, groups: [...clientsFilterConfig.groups, ...(activity ? [activity.filterGroup] : [])] }}
      values={{
        query: filters.search,
        tipoCliente: filters.tipoCliente,
        activity: activity?.overview || '',
      }}
      onChange={(key, value) => {
        if (key === 'query') onSearchChange(value);
        if (key === 'tipoCliente') onTipoChange(value || CLIENT_TYPES.ALL);
        if (key === 'activity') activity?.setFilter(value);
      }}
      onReset={onReset}
    />
  );
}

export default ClientsFilters;
